import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/brand";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminProducts() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/products").then(r => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Archive?")) return;
    await api.delete(`/admin/products/${id}`);
    toast.success("Archived"); load();
  };

  return (
    <div>
      <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">Catalogue</p>
      <h1 className="font-editorial text-5xl mb-16 tracking-tight">Products</h1>
      <div className="border border-ivory/10">
        <div className="grid grid-cols-12 py-4 px-6 text-[10px] tracking-widest-plus uppercase text-ivory/50 border-b border-ivory/10">
          <div className="col-span-5">Piece</div>
          <div className="col-span-2">Chapter</div>
          <div className="col-span-2">Availability</div>
          <div className="col-span-2 text-right">Price</div>
          <div className="col-span-1"></div>
        </div>
        {items.map(p => (
          <div key={p.id} data-testid={`admin-product-${p.slug}`} className="grid grid-cols-12 py-3 px-6 items-center border-b border-ivory/5 text-sm">
            <div className="col-span-5 flex items-center gap-4">
              <img src={p.images?.[0]} alt="" className="w-10 h-12 object-cover" />
              <span>{p.name}</span>
            </div>
            <div className="col-span-2 font-editorial text-lg">{p.chapter_roman}</div>
            <div className="col-span-2 text-[10px] tracking-widest-plus uppercase text-gold">{p.availability}</div>
            <div className="col-span-2 text-right">{formatINR(p.price)}</div>
            <div className="col-span-1 text-right">
              <button onClick={() => remove(p.id)} aria-label="Archive" className="text-ivory/40 hover:text-gold"><Trash2 className="w-4 h-4" strokeWidth={1.25} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
